module.exports = __webpack_public_path__ + "img/0016.aca00d26.jpg";